import { formatDateMethod3 } from "../../utils/formatarData";

const retornaRaca = (raca) => {
  switch (raca) {
    case "branco":
      return "01";
    case "pardo":
      return "03";
    case "preto":
      return "02";
    case "amarelo":
      return "04";
    case "indigena":
      return "05";
  }
};

export default function Insert(dados, setData) {
  if (dados) {
    const dadosPaciente = dados["paciente"];
    const dadosRegistro = dados["registro"];

    if (dadosPaciente["Nome"]) {
      setData.handleSetDataForm("nome", dadosPaciente["Nome"]);
    }

    if (dadosPaciente["Nome da mãe"]) {
      setData.handleSetDataForm("nomeMae", dadosPaciente["Nome da mãe"]);
    }

    if (dadosPaciente["Email"]) {
      setData.handleSetDataForm("email", dadosPaciente["Email"]);
    }
    if (dadosPaciente["Data de nascimento"]) {
      const dtNascimento = dadosPaciente["Data de nascimento"];
      setData.handleSetDataForm(
        "dataNascimento",
        formatDateMethod3(dtNascimento)
      );
    }

    if (dadosPaciente["Raça"]) {
      const raca = dadosPaciente["Raça"];
      setData.handleSetDataForm("raca", retornaRaca(raca));
    }

    if (dadosPaciente["Sexo"]) {
      const sexo = dadosPaciente["Sexo"];
      if (sexo === "F") {
        setData.handleSetDataForm("sexo", "female");
      }
      if (sexo === "M") {
        setData.handleSetDataForm("sexo", "male");
      }
    }

    if (dadosRegistro["Cidade onde nasceu"]) {
      const estadoIBGE =
        dadosRegistro["Cidade onde nasceu"]["Código do estado"];
      const estadoNome = dadosRegistro["Cidade onde nasceu"]["Estado"];
      const estadoSigla = dadosRegistro["Cidade onde nasceu"]["Sigla"];
      const municipioIBGE = dadosRegistro["Cidade onde nasceu"]["Código IBGE"];

      const estadoSelecionado = {
        codigo_uf: estadoIBGE,
        uf: estadoSigla,
        unidade_federativa: estadoNome,
      };
      setData.handleSetDataForm("estadoNascimento", estadoSelecionado);

      setData.handleEstado(estadoSelecionado);
      setData.handleSetDataForm("municipioNascimento", parseInt(municipioIBGE));
      setData.handleSetDataForm("naturalidade", 23);
    }

    if (dadosPaciente["Telefone"]) {
      setData.handleSetDataForm("telefones", [
        {
          id: 1,
          telefone: dadosPaciente["Telefone"],
          nome: dadosPaciente["Nome"],
        },
      ]);
    }
  }
}
